<div class="mb-2">
    <app-company-filter [locationLevel]="config.location_level" [sniLevel]="config.sni_level" [enableSite]="config.object_recognition" (onChange)="filterChange($event)" [enableCategory]="true" context="network"></app-company-filter>
</div>
<app-table [columns]="columns" [data]="selectedSavings" [settings]="settings" [loading]="loading" [selectors]="selectors"
    (selectorChange)="onSelectorChange($event)">
    <ng-template #row let-item="item">
        <measure-details [measure]="item" [currency]="currency"></measure-details>
        <hr>
    </ng-template>
</app-table>